import { setUnreadListFailed, setUnreadListPending, setUnreadListSucceed } from './actions';
import { IChatListRequest } from '../chatList/types';
import { isShowSubAgentChatListSelector } from '../../selectors';
import { CHATS_ON_PAGE_LIMIT } from '../../types/chatList';
import { TThunkAction } from '../../types/redux/thunk';
import { ERoute } from '../../types/route';
import { setRoute } from '../route';
import { fetchUnreadChats } from '../../services/fetchUnreadChats';

/**
 * Получить список непрочитанных чатов
 * FIXME: Пока ручки для получения всех непрочитанных нет, берем из обычных чатов
 */
export const getUnreadChats =
  ({ timestamp }: IChatListRequest): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    const state = getState();

    const {
      masterFilters: { selectedSubAgentId },
    } = state;

    const subAgentRealtyUserId = isShowSubAgentChatListSelector(state) ? selectedSubAgentId : undefined;

    dispatch(setUnreadListPending({ timestamp }));

    const unreadChats = await fetchUnreadChats(context, {
      parameters: {
        limit: CHATS_ON_PAGE_LIMIT,
        timestampMs: timestamp,
        subAgentRealtyUserId,
      },
    });

    if (!unreadChats) {
      dispatch(setUnreadListFailed());

      return;
    }

    dispatch(setUnreadListSucceed(unreadChats));

    /**
     * Ставим активный пункт меню - сообщения
     */
    dispatch(setRoute({ route: ERoute.Unread }));
  };
